import React, { useEffect, useState } from 'react';
import ReactTypingEffect from 'react-typing-effect';
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";
import './HeroSection.css';

const HeroSection = () => {
  return (
    <>
        <div className="slide-in-element hero-section">
            <ScrollAnimation animateIn="fadeIn" animateOnce>
            <div className="hero-text mr-2 md:mr-8">
              <div>
                <h2 className="hero-hello mb-4">
                  <ReactTypingEffect
                    const text = {[
                      "Hello",
                      "Hola ",      // Spanish
                      "Bonjour ",   // French
                      "Salam ",     // Persian
                      "Hallo ",     // German
                      "Olá ",       // Portuguese
                      "Привет ",    // Russian
                      "こんにちは ",    // Japanese
                      "Merhaba ",   // Turkish
                    ]}
                    speed={150}
                    eraseDelay={3000}
                    typingDelay={1000}
                    cursor="_"
                  />
                </h2>
              </div>
              <div className="-mt-2 md:-mt-2 mb-4">
                  <h2 className='hero-title'>I'm Rabii.</h2>
              </div>
              <p className='hero-para -mt-4 mb-4'> I'm a <span className='italic'>Product Engineer </span>
              passionate about Human-Computer Interaction. I work on turning user research into well-designed, functional web experiences.
              </p>
              <p className='hero-para mb-4'>Based in Paris, France <span>🇫🇷</span></p>
              <button className='hero-button'>
                <a href="/contact" className="font-bold"><h2 className='font-normal'>Get in Touch ➤</h2></a>
              </button>
            </div>
            </ScrollAnimation>
            <div className="hero-image-div">
              <ScrollAnimation animateIn="fadeIn" animateOnce>
                <div className='image-compo'>
                  <img className="image-hero" loading='lazy' decoding="async" src="https://i.imgur.com/ryhGEpo.jpeg"></img>
                  <h4 className="image-text">⏤ My Bachelor's Degree Graduation (with Highest honors), 2023.</h4>
                </div>
              </ScrollAnimation>
            </div>
        </div>
    </>
  );
};

export default HeroSection;
